module.exports = __webpack_public_path__ + "img/2024112901.0e6f9d91.png";